export { default as Parser } from './Parser'
export { default as Identifier } from './Identifier'
export { default as Arguments } from './Arguments'
export { default as Ternary } from './Ternary'
export { default as Node } from './Node'

export { default as parseObjectLiteral } from './preparse'

// Importing operators registers the strictEquality option on ko.options
import './operators'
